/* globals Class, lp, jui */
var _ = require('lodash');

var banzai = require('ub/control/banzai-features');
var svgHelper = require('ub/ui/svg/svg-helper.js').default;
var getImageElementPublishUrls = require('ub/control/image-publish-urls').getImageElementPublishUrls;

function scaleImageToPage(imageSize) {
  var scaleFactor = window.editor.page.getContentWidth() / imageSize.width;
  imageSize.width = Math.round(imageSize.width * scaleFactor);
  imageSize.height = Math.round(imageSize.height * scaleFactor);
  return {
    imageSize: imageSize,
    elementSize:{width: imageSize.width, height: imageSize.height}
  };
}

var ImageElement = Class.create(
  lp.pom.VisibleElement,
  lp.ModuleComponent,
  {
    type: 'lp-pom-image',

    getCSSSelector: function() {
      return '#' + this.id;
    },

    _getTarget: function() {
      var target = this.model.safeGet('content.target');

      if (this.model.get('action.type') === 'phone') {
        // 'tel:' links do not work in iOS when the page is in an Iframe (e.g. lightbox), unless the
        // link has a target of '_top' or '_blank'. On some platforms '_blank' causes a new empty
        // tab to be opened, but '_top' seems to work well across all platforms with no side
        // effects. (See CN-713)
        return '_top';
      }

      if (this.page.isFormConfirmation() && !target) {
        return '_parent';
      }

      return target || '';
    },

    initView: function(){
      /* jshint maxcomplexity:14 */
      var innerContainer = this.view.insert(new jui.Component({attributes:{className:'lp-pom-image-container'}}));
      var imageContainer = innerContainer;
      var src = this.model.get('content.asset.content_url');

      var applyTo = {
        juiComponent: innerContainer,
        elm: innerContainer.e,
        selector: this.getCSSSelector() + ' .' + innerContainer.e.className
      };

      this.imgSrcData = {
        desktop : '',
        mobile  : ''
      };

      innerContainer.e.style.overflow = 'hidden';

      this.applyBorderTo = applyTo;
      this.applyDimensionsTo = applyTo;

      if (!this.model.exists('geometry.transform')) {
        var size = this.model.get('geometry.size');
        this.model.set('geometry.transform', {
          offset: {left:0, top:0},
          size: {width: size.width, height: size.height}
        });
        this.model.set('content.asset.size', {width: size.width, height: size.height});
        this.model.set('geometry.maintainAR', true);
        this.model.set('geometry.aspectRatio', size.width / size.height);
      }

      if (this.page.isPublishOrPreviewMode()) {
        var enabledBreakpoints = this.page.getEnabledBreakpoints();

        var attributes = enabledBreakpoints.reduce(function(accAttributes, breakpoint) {
          if (this.model.isVisible(breakpoint.name)) {
            getImageElementPublishUrls(this.model, breakpoint)
              .forEach(function(url, resolutionIndex) {
                accAttributes['data-src-' + breakpoint.name + '-' + (resolutionIndex + 1) + 'x'] = url;
              });
          }

          return accAttributes;
        }.bind(this), {
          // <img> elements are published with this placeholder image as the 'src' attribute, as
          // well as a series of 'data-src-*' attributes - for each breakpoint and available
          // resolution (1x, 2x, 3x). The lp-form/public/main.js script runs on the published page
          // and sets the 'src' and 'srcset' attributes to real image URLs from the relevant
          // 'data-src' URLs. We do this because images can differ between breakpoints because we
          // allow the user to scale and crop them on each breakpoint independently, and we want to
          // make sure that we only load the relevant version of the image in the visitor's browser,
          // e.g. larger desktop images should not start to load on mobile devices.
          src: '//assets.unbounce.com/m/lp-webapp/transparent.gif',
          alt: this.model.safeGet('content.alt') || '',
        });

        this.img = new Element('img', attributes);

        if (this.model.exists('content.title')) {
          this.img.writeAttribute('title', this.model.get('content.title'));
        }

        var href = this.model.getCurrentActionValue();

        if (href) {
          imageContainer = new Element('a', {
            href: this.page.CTAifyLink(href),
            target: this._getTarget(),
          });

          if (this.page.getConfigValue('addGoalAttributeToLinks') && this._urlIsActiveGoal()) {
            imageContainer.writeAttribute('data-goal', 'true');
          }

          innerContainer.insert(imageContainer.insert(this.img));
        }

        imageContainer.insert(this.img);
      } else {
        // isEditMode
        this.img = new Element('img', { src: src });

        imageContainer.insert(this.img);

        if (!(this.model.get('geometry.transform.size.width') === 0 && this.model.get('geometry.transform.size.height') === 0)) {
          this.updateImagePosition();
          this.updateImageSize();
        }
      }

      if (this.page.allowExternalLightboxes()) {
        if ( ! this.model.exists('lightboxSize')) {
          this.model.set('lightboxSize', ImageElement.lightboxSizeDefault);
        }
      }

      if (banzai.features.isSvgColorEnabled() && this.model.isSvg()) {
        svgHelper.fetchSvg(this, src, imageContainer, this.page.isPublishOrPreviewMode());
        svgHelper.updateStyle(this);
      }

    },

    updateImagePosition: function() {
      var offset = this.model.getTransformOffsetAdjustedForInnerBorder();
      if (this.page.isEditMode()) {
        this.img.style.marginLeft = offset.left + 'px';
        this.img.style.marginTop = offset.top + 'px';
      }
    },

    getModelClass: function() {
      return lp.module.image.ImageModel;
    },

    setDimensions: function($super,dims) {
      $super(dims);
      if(this.page.isPublishOrPreviewMode()) {
        var options = {};
        if (this.applyDimensionsTo && this.applyDimensionsTo.selector) {
          // BUG options is not defined
          options.selector = this.applyDimensionsTo.selector + ' img';
        }
        this.applyPageStyles([
          {attribute:'width', value:dims.width+'px'},
          {attribute:'height', value:dims.height+'px'}
        ], options);
      }
    },

    createImageObserver: function(center, autoscale, hideLoader) {
      center = center || false;
      autoscale = autoscale || false;
      this.model.setVisible(false);
      var self = this;
      this.imageObserver = function() {
        self.updateImageDimensions(center, autoscale, hideLoader);
      };

      return this.imageObserver;
    },

    replaceImage: function(asset) {
      this.page.undoManager.registerUndo({
        action: this.replaceImage,
        receiver: this,
        params: [Object.clone(this.model.get('content.asset'))]
      });
      this._replaceImage(asset);
    },

    _replaceImage: function(asset) {
      window.editor.wait();
      window.editor.imageTransformBox.hide();
      this.img.observe('load', this.createImageObserver());
      this.model.set('content.asset', {
        company_id: asset.company_id,
        uuid: asset.uuid,
        unique_url: asset.unique_url,
        content_url: asset.content_url,
        content_content_type: asset.content_content_type,
        name: asset.name
      });

      this.model.set('name', asset.name);
    },

    doubleClick: function(){
      var self = this;
      this.getModule().openElementBuilder(this, {
        callback: function(asset){
          if (asset && self.isAssetReplaceable(asset.uuid, asset.name)) {
            self.replaceImage(asset);
          }
        },
        selectedAsset: self.model.get('content.asset')
      });
    },

    isAssetReplaceable: function(uuid, name) {
      return !this.isUUIDTheSame(uuid) || !this.isNameTheSame(name);
    },

    isUUIDTheSame: function(uuid) {
      return uuid === this.model.get('content.asset.uuid');
    },

    isNameTheSame: function(name) {
      return name === this.model.get('content.asset.name');
    },

    isWidthResizeable: function() {
      return true;
    },

    isHeightResizeable: function() {
      return true;
    },

    isResizeable: function() {
      return true;
    },

    setModelAttributes: function(ar, assetSize, imageSize, imageOffset, elementSize, center) {
      var m = this.model;
      m.set('geometry.aspectRatio', ar);
      m.set('content.asset.size', assetSize);
      m.set('geometry.transform.size', imageSize);
      m.set('geometry.transform.offset', imageOffset);
      m.set('geometry.size', elementSize);
      m.set('geometry.maintainAR', true);

      if (center) {
        // TODO-TR: this code was moved from elsewhere ... it might
        // be ok to just use elementSize and imageOffset here
        // instead of querying the model.
        var size   = m.getSize()
          , offset = m.getOffset();

        m.setOffset({
          left: offset.left - Math.round(size.width / 2),
          top:  offset.top - Math.round(size.height / 2)
        });
      }

      if( ! this.page.getCurrentBreakpoint().default) {
        //If image is being created in the non-default breakpoint
        //we need to make sure that dimensions are transfered to
        //that breakpoint.
        this.model.syncDimensions(imageSize);
      }
      this.fireEvent('imageChanged');
      this.show();
    },

    updateImageDimensions: function(center, autoscale, hideLoader) {
      center = center || false;
      var m    = this.model
        , self = this;

      this.img.stopObserving('load', this.imageObserver);
      var currentSize = m.get('geometry.size');
      this.resetImageSize();
      var assetSize   = {width:this.img.width, height:this.img.height}
        , imageSize   = {width:this.img.width, height:this.img.height}
        , imageOffset = {left: 0, top: 0}
        , ar          = assetSize.width / imageSize.height;

      if(!hideLoader){
        window.editor.stopWaiting();
      }

      var dialog;

      var imageLargerThanPage = imageSize.width > window.editor.page.getContentWidth();

      function updateElement(autoscale, self) {
        var sizes;
        m.setVisible(true);
        if( autoscale && imageLargerThanPage ){
          sizes = scaleImageToPage( imageSize );
        } else {
          sizes = {
            imageSize: imageSize,
            elementSize: { width: imageSize.width, height: imageSize.height }
          };
        }
        self.setModelAttributes(ar, assetSize, sizes.imageSize, imageOffset, sizes.elementSize, center);
        if (currentSize.width === 0 && currentSize.height === 0) {
          self.page.insertElement(self, {container: self.page.getElementById(self.containerId)});
        }
        window.editor.imageTransformBox.show();
        window.editor.imageTransformBox.updatePositioning();
      }

      if(autoscale) {
        updateElement(autoscale, this);
      } else {
        if (
          (currentSize.width !== 0 && currentSize.height !== 0) &&
          (assetSize.width !== currentSize.width || assetSize.height !== currentSize.height)
        ) {
          /* scale and crop to fit */
          var replaceMsg = [
            'The image you have chosen is not the same size as the',
            'image being replaced. Would you like to scale',
            'the new image to fit the size of the replaced image?'
          ].join(' ');
          dialog = new jui.MultiOptionDialog({
            classNames            : ['image-too-big'],
            clickOutsideWillClose : false,
            elementId             : this.id,
            uiBinding             : window.editor.dialogManager.getUIBinding('imageScaling'),
            message               : new Element('p').update(replaceMsg),
            options               : [
              {label: 'Don\'t Scale',       eventType: 'selectDontScaleButtonWhileReplacingImage'},
              {label: 'Scale Image to Fit', eventType: 'selectScaleButtonWhileReplacingImage'}
            ],
            onClose: function() {
              self.model.setVisible(true);
              window.editor.imageTransformBox.show();
              window.editor.imageTransformBox.updatePositioning();
              self.fireEvent('shown');
            }
          });

          // When the dialog is showing during adding an image, looking up the image by ID
          // won't work – and the event subscriber needs it. So we store a reference to it
          // in the dialog manager.
          window.editor.dialogManager.openDialog(dialog, {imageElm: this});

        } else if ( imageLargerThanPage ) {
          var pageWidthMsg = [
            'The image you have chosen is wider than',
            'the page. Would you like to scale it to fit within the page',
            'or keep it full size?'
          ].join(' ');
          dialog = new jui.MultiOptionDialog({
            classNames            : ['image-too-big'],
            clickOutsideWillClose : false,
            elementId             : this.id,
            uiBinding             : window.editor.dialogManager.getUIBinding('imageScaling'),
            message               : new Element('p').update(pageWidthMsg),
            options               : [
              {label: 'Use Full Size',           eventType: 'selectDontScaleButtonWhileCreating'},
              {label: 'Scale Image to Fit Page', eventType: 'selectScaleButtonWhileCreating'}
            ],
            onClose: function() {
              self.model.setVisible(true);
              self.page.insertElement(self, {container: self.page.getElementById(self.containerId)});
            }
          });
          window.editor.dialogManager.openDialog(dialog, {imageElm: this});
        } else {
          updateElement(false, this);
        }
      }
    },

    resetImageSize: function() {
      this.img.style.width = '';
      this.img.style.height = '';
    },

    updateImageSize: function() {
      var size = this.model.safeGet('geometry.transform.size');
      //Prevent image from being set to anything less than 1px.
      if(size && size.width > 0 && size.height > 0) {
        if(this.page.isEditMode()) {
          this.img.style.width = size.width + 'px';
          this.img.style.height = size.height + 'px';

          // This syncs the view to the size of the image mask
          if (this.model.safeGet('geometry.size.width') > 0 &&
              this.model.safeGet('geometry.size.height') > 0) {
            this.view.e.style.width = this.model.safeGet('geometry.size.width') + 'px';
            this.view.e.style.height = this.model.safeGet('geometry.size.height') + 'px';
          } else {
            this.view.e.style.width = size.width + 'px';
            this.view.e.style.height = size.height + 'px';
          }
        }
      }
    },

    updateElementGeometry: function($super) {
      $super();
      this.updateImagePosition();
      this.updateImageSize();
    },

    removeTransformations: function() {
      var m = this.model;
      var size = m.get('content.asset.size');
      m.setSize({width:size.width, height:size.height});
      m.set('geometry.aspectRatio', size.width / size.height);
      m.set('geometry.transform.size', {width:size.width, height:size.height});
      m.set('geometry.transform.offset', {left: 0, top: 0});
    },

    modelChanged: function($super, e) {
      var details = $super(e);

      if (details.accessor === 'content.asset') {
        this.hide();
        this.img.src = this.page.decorateImageSrc(details.value.content_url);
      } else if (details.accessor === 'content.link') {
        this.fireEvent('goalChanged', this);
      } else if (details.accessor === 'geometry.size') {

      } else if (details.accessor === 'geometry.maintainAR') {
        if (details.value) {
          var m = this.model;
          m.set('geometry.aspectRatio', m.getWidth() / m.getHeight());
        }
      } else if (details.accessor.startsWith('geometry.transform.offset')) {
        this.updateImagePosition();
      } else if (details.accessor.startsWith('geometry.transform.size')) {
        this.updateImageSize();
      } else if (details.accessor === 'svgColors') {
        svgHelper.updateStyle(this);
      }
    },

    applyBorder: function($super, value) {
      $super(value);
      if (this.page.isEditMode()) {
        this.updateImagePosition();
      }
    },

    canHaveGoals: function() {
      return true;
    },

    getGoals: function() {
      var type = this.model.safeGet('action.type');

      if ( ! type) { return []; }

      var typeMap = {
        'url': 'link',
        'externalLightbox': 'link',
        'phone': 'phone'
      };

      var actionValue = this.model.getCurrentActionValue();

      if (actionValue && ! /^(#|mailto\:)/.test(actionValue)) {
        return [{
          type : typeMap[type],
          url  : actionValue
        }];
      } else {
        return [];
      }
    },

    appendURLParams: function() {
      return this.model.safeGet('content.passparams') || false;
    },

    _urlIsActiveGoal: function() {
      var url = this.model.safeGet('content.link');
      return url && this.page.goals && this.page.goals.urlIsActiveGoal(url);
    }
  }
);

ImageElement.scalingDialogUIBindingHandler = function(ev) {
  // Class method.
  // Editor subscribes this method to the image scaling dialog UI binding.

  var elm = window.editor.page.getElementById(ev.elementId) ||
    window.editor.dialogManager.getCurrentDialog().imageElm;

  var currentSize = elm.model.get('geometry.size')
    , assetSize   = {width: elm.img.width, height: elm.img.height}
    , imageSize   = {width: elm.img.width, height: elm.img.height}
    , imageOffset = {left: 0, top: 0}
    , ar          = assetSize.width / imageSize.height
    , elementSize
    , scaleFactor;

  // Handlers for each of the dialogs' action buttons
  var domainEvents = {
    selectDontScaleButtonWhileReplacingImage: function() {
      elementSize = {width: imageSize.width, height: imageSize.height};
      elm.setModelAttributes(ar, assetSize, imageSize, imageOffset, elementSize);
    },

    selectScaleButtonWhileReplacingImage: function() {
      var currentAR = currentSize.width / currentSize.height;
      if (currentAR > ar) {
        scaleFactor      = currentSize.width / imageSize.width;
        imageSize.width  = Math.round(imageSize.width * scaleFactor);
        imageSize.height = Math.round(imageSize.height * scaleFactor);
        imageOffset.top  = Math.round((currentSize.height - imageSize.height) / 2);
      } else {
        scaleFactor      = currentSize.height / imageSize.height;
        imageSize.width  = Math.round(imageSize.width * scaleFactor);
        imageSize.height = Math.round(imageSize.height * scaleFactor);
        imageOffset.left = Math.round((currentSize.width - imageSize.width) / 2);
      }
      elementSize = {width: currentSize.width, height: currentSize.height};
      elm.setModelAttributes(ar, assetSize, imageSize, imageOffset, elementSize);
    },

    selectDontScaleButtonWhileCreating: function() {
      elementSize = {width: imageSize.width, height: imageSize.height};
      elm.setModelAttributes(ar, assetSize, imageSize, imageOffset, elementSize);
    },

    selectScaleButtonWhileCreating: function() {
      var sizes = scaleImageToPage(imageSize);
      elm.setModelAttributes(ar, assetSize, sizes.imageSize, imageOffset, sizes.elementSize);
    }
  };

  // Call the relevant handler
  var handler = domainEvents[ev.type];
  if (_.isFunction(handler)) {
    handler();
  } else if (banzai.features.isDebugModeEnabled()){
    console.warn('No domain event handler for type', ev.type);
  }

  // Close the dialog
  window.editor.dialogManager.closeCurrentDialog();
};

ImageElement.elementDefaults = {
  name:     'Image',
  geometry: {
    position:       'absolute',
    offset:         {top:   0, left:   0},
    size:           {width: 0, height: 0},
    borderLocation: 'outside',
    maintainAR:     true,
    transform:      {
      offset: {left:  0, top:    0},
      size:   {width: 0, height: 0}
    }
  },
  action: {
    type: 'url'
  },
};

ImageElement.lightboxSizeDefault = {
  width: 840,
  height: 480
};

module.exports = ImageElement;



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-image/image_element.js
// module id = 553
// module chunks = 0 1